
export function closeBanner() {
    const cross = document.getElementById('cross-banner-estimation-success')
    if (cross) {
        const banner = document.getElementById('banner-estimation-success')
        cross.addEventListener('click', () => banner.classList.add('hidden'))
    }
}
